package horcrux.frontend.common.views.chat

import js.objects.jso
import mui.material.PaletteMode
import mui.system.createTheme
import web.cssom.pt

object Theme {
    val theme = createTheme(
    jso {
        this.palette = jso { this.mode = PaletteMode.light }
        this.typography = jso {
            this.fontFamily = "Roboto"
            this.pxToRem = { 10.0 }
        }
        this.shape = jso {
            this.borderRadius = 10.pt
        }

        this.palette = jso {
            this.mode = PaletteMode.dark
            this.primary = jso {
                main = "#3b3b3b"
                light = "#757575"
                dark = "#212121"
                contrastText = "#e8e8e8"
            }
            this.secondary = jso {
                main = "#f48fb1"
                light = "#f0afc5"
                dark = "#fff"
            }
            this.background = jso {
                default = "#303030"
                paper = "#3b3b3b"
            }
            this.grey = mapOf(
                400 to "#303030",
                600 to "#303030"
            )
        }
    }
)
}
